import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { getPageProperty, PolotnoStoreActivePageKeys } from '@/pages/AdvancedEditor/hooks';
import { DeleteItem } from '../options/DeleteItem';

export const DeleteContextualMenu = () => {
    const { store } = useAdvancedEditorContext();
    const isThereAnySelectedLockedElement = getPageProperty(store.activePage, PolotnoStoreActivePageKeys.isThereAnySelectedLockedElement);

    return !isThereAnySelectedLockedElement ? <DeleteItem /> : null;
};
